import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { CargoGroups } from "./CargoGroups";

export const CargoGroupsDialog = ({ stops, onClose }) => (
  <Dialog open onOpenChange={(open) => { if (!open) onClose(); }}>
    <DialogContent data-testid="cargo-groups-dialog" className="z-[1300] max-w-lg w-[calc(100%-16px)] max-h-[90dvh] overflow-y-auto rounded-2xl bg-zinc-50 p-4" overlayClassName="z-[1290] bg-black/60">
      <DialogTitle>Paczki według miejsca na pace</DialogTitle>
      <DialogDescription>Numer przy adresie to kolejność doręczenia.</DialogDescription>
      <CargoGroups stops={stops} />
    </DialogContent>
  </Dialog>
);
